import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { NzModalRef, NzModalService, NZ_MODAL_DATA, NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private escalationNotices = new Map<number, string>();

  constructor(private notification: NzNotificationService, private router: Router) { }

  public showChatEscalation(incidentId: number, incidentNumber: string, chatMessageId: number, message: string): void {
    const escape = (text: string) => text.replace(/[&<>"']/g, value =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[value]!);
    const notice = this.notification.warning('Service Provider escalation',
      `Incident #${escape(incidentNumber)}: ${escape(message)}<br><a href="/incident/${incidentId}?openChat=true&chatMessageId=${chatMessageId}">Open chat</a>`,
      { nzDuration: 0, nzKey: `chat-escalation-${chatMessageId}` });
    this.escalationNotices.set(chatMessageId, notice.messageId);
    notice.onClick.subscribe(event => {
      event.preventDefault();
      void this.router.navigate(['/incident', incidentId], { queryParams: { openChat: true, chatMessageId } });
    });
    notice.onClose.subscribe(() => this.escalationNotices.delete(chatMessageId));
  }

  public clearChatEscalation(chatMessageId: number): void {
    const notice = this.escalationNotices.get(chatMessageId);
    if (notice) this.notification.remove(notice);
    this.escalationNotices.delete(chatMessageId);
  }

  public showError(message: string, title? : string): void {
    title = title == undefined ? 'Error' : title;
    this.notification.error(title, message);
  }

  public showWarning(message: string, duration: number = 2000): void {
    this.notification.warning('Warning', message, {nzDuration: duration});
  }

  public showWarningTimer(message: string, timer: number): void {
    this.notification.warning('Warning', message, {nzDuration: timer});
  }

  public showSuccess(message: string, duration: number = 2000): void {
    this.notification.success('Success', message, {nzDuration: duration});
  }

  public removeAlert(): void {
    this.notification.remove();
    //this.modal.closeAll();
  }

  public showSuccessMinimal(message: string): void {
    this.notification.success("",message,{nzDuration: 1000});
  }

  public showSuccessPinned(message: string): void {
    this.notification.success('Success', message, {nzDuration: 0});
  }

  public showErrorPinned(message: string): void {
    this.notification.error('Error', message, {nzDuration: 0});
  }

  public showInfo(message: string, duration: number = 2000): void {
    this.notification.info('Info', message, {nzDuration: duration});
  }

  public handleError(error: any, message? : string, title?: string): void {
    const body = error?.error;
    let detail = body?.field && body?.message
      ? `${body.field} ${body.message}`
      : body?.detail || body?.message;
    if (Array.isArray(detail)) {
      detail = detail.map((item: any) => typeof item === 'string' ? item : item?.msg)
        .filter(Boolean).join('; ');
    }
    const msg = (typeof detail === 'string' && detail)
      || (typeof body === 'string' && body)
      || (typeof error === 'string' && error)
      || (error?.status === 0
        ? 'Unable to reach the server. Please check your connection and try again.'
        : error?.message || error?.statusText)
      || 'An unexpected error occurred. Please try again.';
    this.showError(message ? `${message} :: ${msg}` : msg, title);
  }

  public showWarningWithButton(message: string, buttonText: string, redirectUrl: string): void {
    const notificationRef = this.notification.warning('Warning', message, {
      nzDuration: 0,
      nzData: { buttonText, redirectUrl }
    });

    // Add button after notification is created
    setTimeout(() => {
      const notificationElement = document.querySelector('.ant-notification-notice:last-child .ant-notification-notice-description');
      if (notificationElement) {
        const buttonContainer = document.createElement('div');
        buttonContainer.style.marginTop = '10px';
        const button = document.createElement('button');
        button.innerText = buttonText;
        button.className = 'ant-btn ant-btn-primary ant-btn-sm';
        button.onclick = () => {
          this.router.navigate([redirectUrl]);
          this.notification.remove();
        };
        buttonContainer.appendChild(button);
        notificationElement.appendChild(buttonContainer);
      }
    }, 0);
  }

  public showInformationWithButton(message: string, buttonText: string, redirectUrl: string): void {
    const notificationRef = this.notification.info('Info', message, {
      nzDuration: 0,
      nzData: { buttonText, redirectUrl }
    });

    // Add button after notification is created
    setTimeout(() => {
      const notificationElement = document.querySelector('.ant-notification-notice:last-child .ant-notification-notice-description');
      if (notificationElement) {
        const buttonContainer = document.createElement('div');
        buttonContainer.style.marginTop = '10px';
        const button = document.createElement('button');
        button.innerText = buttonText;
        button.className = 'ant-btn ant-btn-primary ant-btn-sm';
        button.onclick = () => {
          this.router.navigate([redirectUrl]);
          this.notification.remove();
        };
        buttonContainer.appendChild(button);
        notificationElement.appendChild(buttonContainer);
      }
    }, 0);
  }

  
}
